import { Timestamp } from "firebase/firestore";
import { MaskHelper, SearchHelper } from "../../utils/helpers";

/**
 * Converte dados do form para enviar ao Firestore.
 */
export const tenantToFirestore = (data, authUser) => {
    // Note que não precisamos exigir um ID de tenant para "salvá-lo", pois a collection é /tenants e o id dele é gerado lá (ou se já tiver id, usamos)
    const tradeName = data.tradeName?.trim() || "";

    const payload = {
        tradeName,
        searchName: SearchHelper.normalize(tradeName),
        corporateName: data.corporateName?.trim() || "",
        document: MaskHelper.unmask(data.document),
        
        email: data.email?.toLowerCase().trim() || "",
        phone: MaskHelper.unmask(data.phone),
        website: data.website?.trim() || "",
        
        logoUrl: data.logoUrl,
        brandColor: data.brandColor,

        // Endereço (flat form para nested data object)
        address: {
            zipCode: MaskHelper.unmask(data.zipCode),
            street: data.address?.trim() || "",
            number: data.number?.trim() || "",
            complement: data.complement?.trim() || "",
            neighborhood: data.neighborhood?.trim() || "",
            city: data.city?.trim() || "",
            state: data.state?.trim() || "",
            country: data.country},

        // Representante
        legalRepresentative: {
            name: data.legalRepresentative?.name?.trim() || "",
            cpf: MaskHelper.unmask(data.legalRepresentative?.cpf),
            email: data.legalRepresentative?.email?.toLowerCase().trim() || "",
            phone: MaskHelper.unmask(data.legalRepresentative?.phone)
        },

        // Status inicial de criação
        isActive: data.isActive === undefined ? true : !!data.isActive, // por padrão true

        // Timestamp / Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? (data.createdBy || null) : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove undefineds para não dar erro no firestore
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    
    return payload;
};

/**
 * Converte dados do Firestore para uso no Formulário/React.
 */
export const tenantFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        
        // Desencapsula o Endereço para usar no Formulario em modo flat
        zipCode: data.address?.zipCode,
        address: data.address?.street,
        number: data.address?.number,
        complement: data.address?.complement,
        neighborhood: data.address?.neighborhood,
        city: data.address?.city,
        state: data.address?.state,
        country: data.address?.country,

        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
